import { render, staticRenderFns } from "./EditCustomerModal.vue?vue&type=template&id=4f5f9a9d&scoped=true"
import script from "./EditCustomerModal.vue?vue&type=script&lang=js"
export * from "./EditCustomerModal.vue?vue&type=script&lang=js"
import style0 from "./EditCustomerModal.vue?vue&type=style&index=0&id=4f5f9a9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f9a9d",
  null
  
)

export default component.exports